'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { AppDownloadBottomSheet } from '~/components';
import { useEnvironmentInfo } from '~/hooks';

/** 웹 환경에서 로드시 앱 다운로드 팝업을 보여준다. (query parameter `hide-app-nudge=true`인 경우 제외) */
export const AppDownloadScreen = () => {
  const { isWebview } = useEnvironmentInfo();
  const [visible, setVisible] = useState<'BOTTOM_SHEET'>();

  const searchParams = useSearchParams();
  const shouldHideAppNudge = searchParams.get('hide-app-nudge') === 'true';

  useEffect(() => {
    setVisible('BOTTOM_SHEET');
  }, []);

  if (isWebview || shouldHideAppNudge) return null;

  return <AppDownloadBottomSheet isOpen={visible === 'BOTTOM_SHEET'} onClose={() => setVisible(undefined)} />;
};
